import { clientApp } from './index';

export const getAccounts = (type: string) => clientApp.get(`/ui/wix/settings/account/${type}`);

export const checkSubscription = () => clientApp.get(`/ui/wix/subscription`);

export const postCheckout = () => clientApp.post(`/ui/wix/subscription/checkout`, { url: process.env.REACT_APP_FE_URL });
